import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import "@/App.css";
import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n/I18nProvider";
import SiteLayout from "@/layouts/SiteLayout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function LangGate() {
  const { lang } = useParams();
  const normalized = SUPPORTED_LANGS.includes(lang) ? lang : null;
  if (!normalized) return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  // sync document lang
  if (typeof document !== "undefined") document.documentElement.lang = normalized;
  return (
    <I18nProvider lang={normalized}>
      <SiteLayout />
    </I18nProvider>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<LangGate />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<LegalPage docKey="privacy" />} />
            <Route path="cookie-policy" element={<LegalPage docKey="cookiePolicy" />} />
            <Route path="terms" element={<LegalPage docKey="terms" />} />
          </Route>
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
